// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__vPf54"};